<template>
    <div class="popup popup-bankProcess" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  id="bankPopup">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>银行转账流程</p>
            <a class="shorexDetail-returnButton" @click="onGoBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="bankProcess-content">
            <div class="bankProcess-m">
                <div class="lineTitle">
                    <div class="lineTitle-line"></div>
                    请汇款至以下账户：
                </div>
                <div class="bankProcess-txt">
                    账户名：皇家加勒比游轮船务（中国）有限公司<br>
                    银行名：摩根大通银行（中国）有限公司上海分行<br>
                    银行地址：中国上海市浦东新区银城中路501号上海中心48楼，200120<br>
<!--                    银行地址：中国上海市静安区南京西路 1601 号越洋国际广场 41 楼, 200040<br>-->
                    （直客）人民币账号：5002032000<br>
                </div>
                <div class="bankProcess-cell">
                    支付方式为银行转账/汇款
                </div>
                <img class="bankProcess-arrow" src="https://resource.rcclchina.com.cn/tui2/icon22_down_arrow.png">
                <div class="bankProcess-cell">
                    请务必备注好您的订单号、姓名
                </div>
                <img class="bankProcess-arrow" src="https://resource.rcclchina.com.cn/tui2/icon22_down_arrow.png">
                <div class="bankProcess-cell">
                    银行转账/汇款成功并与客服确认<br>
                    请务必在完成付款后致电400-820-7293与客服确认
                </div>
                <div class="bankProcess-cell" style="background: white;color: #666;text-align: left;">
                    特别提醒：
                    <p>
                        1.若您预订的房型为特定主题房（如巧虎主题房），请您通过线上渠道进行订单支付。线下转账需人工入账且时间较长，会导致您的订单没有及时入账而被系统自动取消。
                        <br>2.若公司转账，退款时需提供所需的公司证明及多份英文材料，退款周期较长，敬请谅解。
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BankPopup",
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        onGoBack: {
            type: Function
        },
    }
}
</script>

<style lang="less" scoped>
#bankPopup.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
}
#bankPopup.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#bankPopup.modal-out {
    transform: translate3d(100%, 0, 0);
}

#bankPopup {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            > img {
                width: 33%;
            }
        }

    }
    .bankProcess-content {
        margin-top: 60px;
        height: 100%;
        overflow: scroll;
        padding-bottom: 60px;
        background-color: #fff;
        .bankProcess-m {
            padding: 14px 20px 8px;
        }
        .bankProcess-txt {
            padding-bottom: 16px;
            font-size: 12px;
            line-height: 20px;
            color: #666;
        }
        .bankProcess-cell {
            width: 100%;
            margin-bottom: 10px;
            padding: 10px 0;
            font-size: 12px;
            line-height: 20px;
            color: #fff;
            text-align: center;
            background: #4A90E2;
        }
        .bankProcess-arrow {
            display: block;
            width: 18px;
            margin: 0 auto 10px;
        }
    }
}
</style>

